module.exports = __webpack_public_path__ + "img/members.98cd8e1e.jpg";